export default __webpack_public_path__ + "static/media/layer7.3300d2a0.svg";